import { render } from "./VillageList.vue?vue&type=template&id=66d60c6a"
import script from "./VillageList.vue?vue&type=script&lang=js"
export * from "./VillageList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/VillageList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66d60c6a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66d60c6a', __exports__)) {
    api.reload('66d60c6a', __exports__)
  }
  
  module.hot.accept("./VillageList.vue?vue&type=template&id=66d60c6a", () => {
    api.rerender('66d60c6a', render)
  })

}


export default __exports__